/**
 * Method that removes the accents so it can match the search terms 
 * @param value is the search term and the value that is gonna be found
 * @returns a sanitized string w/o accents
 */
export const removeAccents = (value: string) => {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

/**
 * handles the order status string value to join it with a middle score so it can style the component
 */
export const handleOrderStatus = (status: string) => {
    const stringArray = status.split(" ");
    const joinedString = stringArray.join("-");
    return joinedString ?? "";
}